import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { business } from '../data/content';
import { useEstimate } from '../contexts/EstimateContext';
export function OutcomeOffer() {
  const {
    openEstimate
  } = useEstimate();
  return <section id="estimate" className="scroll-mt-20 bg-forest py-20 text-white md:py-24" data-id="element-213" data-mp="24e4hhk04yxrm">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 md:px-8 lg:grid-cols-[1.1fr_0.9fr] lg:items-center lg:gap-20" data-id="element-214" data-mp="1zl3095cgim4v">
        <div data-id="element-215" data-mp="2dbeupawikwz6">
          <h2 className="font-display text-3xl font-bold md:text-5xl" data-id="element-216" data-mp="2df2mo5mb9bbs">Imagine This Instead</h2>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/85" data-id="element-217" data-mp="28g9bijuhxwes">
            You pull into your driveway and feel <strong className="text-white" data-id="element-218" data-mp="2iccka8justap">proud</strong>. Clean stone beds, green
            lawn, gleaming concrete — and zero stress getting there.
          </p>
        </div>

        <div className="rounded-2xl bg-white p-8 text-ink shadow-2xl md:p-10" data-id="element-219" data-mp="szil0zgalz67">
          <h3 className="font-display text-3xl font-bold text-forest" data-id="element-220" data-mp="nzw86r4dmkxx">Free Estimate — No Obligation</h3>
          <p className="mt-3 leading-relaxed text-ink-muted" data-id="element-221" data-mp="355ygscvn3cpz">We come out, look at your property, and give you an honest price.</p>
          <a href={business.phoneHref} className="mt-7 flex items-center justify-center gap-3 rounded-lg bg-brick px-6 py-5 font-display text-2xl font-bold text-white transition-[background-color,transform] duration-150 ease-out hover:bg-brick-dark active:scale-[0.98] md:text-3xl" data-id="element-222" data-mp="3e4s9hs5uniy9">
            <PhoneIcon className="h-6 w-6" aria-hidden="true" data-id="element-223" data-mp="3st6lasl8uhqy" />
            {business.phoneDisplay}
          </a>
          <button type="button" onClick={() => openEstimate()} className="mt-3 w-full rounded-lg border border-forest px-6 py-3.5 font-semibold text-forest transition-colors duration-150 hover:bg-forest/5" data-id="element-224" data-mp="pnlkux1keca">
            Request an Estimate Online
          </button>
        </div>
      </div>
    </section>;
}